import { TFileItem, TFileSubfoldersItem } from '@/data/types';
import { State } from '../state/state';

export const getAllFiles = (state: State): TFileItem[] => state.files.items;

export const getCurrentFile = (state: State): TFileItem | null => state.files.currentFile;

export const getFileSubfolders = (state: State): TFileSubfoldersItem[] => state.files.subfolders;
